import { useJobs } from '../hooks/useJobs';
import { Employee } from '../../employees/types';

interface EmployeeJobsViewProps {
  employee: Employee;
}

export function EmployeeJobsView({ employee }: EmployeeJobsViewProps) {
  const { jobs, loading, error } = useJobs();
  
  const employeeJobs = jobs.filter(job => job.employeeId === employee.id);
  
  if (loading) return <div>Loading jobs...</div>;
  if (error) return <div>Error loading jobs: {error}</div>;
  
  return (
    <div className="employee-jobs">
      <h3>Assigned Jobs</h3>
      {employeeJobs.length === 0 ? (
        <p>No jobs assigned</p>
      ) : (
        <ul>
          {employeeJobs.map(job => (
            <li key={job.id}>
              {job.customerName} - {job.status}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}